// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__BTboV4Ds","warning":"SignUpIncorrectBirthStep_warning__5Jp8vPOq","back":"SignUpIncorrectBirthStep_back__5OTlLDU7"};